import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-div-met-inhoudingsvrijstelling-buitenland',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-met-inhoudingsvrijstelling-buitenland.component.html',
  styleUrl: './tekst-met-inhoudingsvrijstelling-buitenland.component.scss',
})
export class TekstMetInhoudingsvrijstellingBuitenlandComponent {}
